import React, { Component } from 'react'
import './ToggleButton.css';

export default class CompareToggleButton extends Component<any, any> {

  constructor(props: any) {
    super(props)

    this.state = {
      selected: 0
    }
  }

  componentWillReceiveProps(nextProps: any) {
    if (!nextProps.enable) {
      this.setState({ selected: 0 })
    }
  }

  toggleState = (e: any) => {

    if (this.props.enable) {
      var newState = this.state.selected ? 0 : 1 // Toggle: if selected (1) -> unselected (0) vice versa 
      this.setState({ selected: newState })

      if (e === undefined)
        this.props.onClick({ isClickToggle: false, newState })
      else {
        this.props.onClick({ isClickToggle: true, newState })
      }
    }
  }

  getWidth(unit: string = '') {
    var width = this.props.width
    if (width) {
      if (typeof width !== 'number')
        width = parseFloat(width.replace(/,/g, ''))
    }
    else
      width = 100

    if (unit) {
      width = width.toString() + unit
    }

    return width
  }

  getHeight(unit: string = '') {
    var height = this.props.height
    if (height) {
      if (typeof height !== 'number')
        height = parseFloat(height.replace(/,/g, ''))
    }
    else
      height = 50

    if (unit) {
      height = height.toString() + unit
    }
    return height
  }

  getBorderRadius(unit: string) {
    let radius: any = Math.min(this.getHeight(), this.getWidth()) / 2

    if (unit)
      radius = radius.toString() + unit

    return radius
  }

  getPadding(unit: string = '') {
    var padding = this.props.padding
    if (padding) {
      if (typeof padding !== 'number')
        padding = parseFloat(padding.replace(/,/g, ''))
    }
    else
      padding = 5

    if (unit) {
      padding = padding.toString() + unit
    }
    return padding
  }

  getHandleWidth(unit: string) {
    let handleWidth: any = Math.min(this.getWidth(), this.getHeight())
    let padding = this.getPadding() * 2 + 2
    if (unit) {
      handleWidth = handleWidth.toString() + unit
    }
    return 'calc(' + handleWidth + ' - ' + padding + 'px)'
  }

  getHandleHeight(unit: string) {
    let handleHeight: any = Math.min(this.getWidth(), this.getHeight())
    let padding = this.getPadding() * 2 + 2
    if (unit) {
      handleHeight = handleHeight.toString() + unit
    }

    return 'calc(' + handleHeight + ' - ' + padding + 'px)'
  }

  getHandlePosition(unit1: string, unit2: string) {
    if (this.state.selected) {
      let width = this.getWidth() - Math.min(this.getWidth(), this.getHeight())
      let padding = this.getPadding() + 1 - (this.getPadding() * 2 + 2)
      return 'calc(' + width + unit1 + ' - ' + padding + unit2 + ')'
    }
    else
      return this.getPadding(unit2)
  }

  getHandleTop(unit: string) {
    return this.getPadding(unit)
  }

  getClass() {
    if (this.props.enable) {
      if (this.state.selected) {
        return 'ToggleButton Selected';
      } else {
        return 'ToggleButton Off';
      }
    } else {
      return 'ToggleButton Disabled';
    }
  }

  render() {
    return (
      <div className={this.getClass()} onClick={this.toggleState} style={{ width: this.getWidth('rem'), height: this.getHeight('rem'), borderRadius: this.getBorderRadius('rem') }}>
        <div className={this.state.selected ? 'ToggleButton-ON' : 'ToggleButton-ON-none'}>ON</div>
        <div className="ToggleButton-Handle" style={{ width: this.getHandleWidth('rem'), height: this.getHandleHeight('rem'), left: this.getHandlePosition('rem', 'px'), top: this.getHandleTop('px') }}></div>
        <div className={!this.state.selected ? 'ToggleButton-OFF' : 'ToggleButton-OFF-none'}>OFF</div>
      </div>
    );
  }
}
